import { render, staticRenderFns } from "./sport-home-banner.vue?vue&type=template&id=22964442"
import script from "./sport-home-banner.vue?vue&type=script&lang=js"
export * from "./sport-home-banner.vue?vue&type=script&lang=js"
import style0 from "./sport-home-banner.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/banners/sport-banners/sport-home-banner.vue
// module id = 162I
// module chunks = 0